module.exports = __webpack_public_path__ + "img/envelope-check.b9a637d9.svg";